export default {
  COOKIES_IDS: {
    ACCESS_TOKEN: 'accessToken',
    ACCESS_TOKEN_ORIGIN: 'accessTokenOrigin',
    AGENT_TOKEN: 'agentToken',
    REFRESH_TOKEN: 'refreshToken',
    USERNAME: 'username'
  },
  LOCALSTORAGE_IDS: {
    COUNTRY: 'country',
    LOCALE: 'locale',
    REFRESH_TOKEN_ALIVE: 'sessionExpiresAt',
    REMEMBER_USER: 'rememberUser',
    TRANSLATIONS: 'translations',
    TRANSLATIONS_VERSION: 'translationsVersion',
    USERNAME: 'username',
    CANCEL_URL: 'cancelUrl',
    SUCCESS_URL: 'successUrl',
    PERSISTENT_DATA: 'persistentData',
    MERCHANT_NAME: 'merchantName',
    PAYMENT_OPTION_TYPE: 'paymentOptionType'
  }
};